import { render } from "./template-file-upload.vue?vue&type=template&id=73c35c66&scoped=true"
import script from "./template-file-upload.vue?vue&type=script&lang=js"
export * from "./template-file-upload.vue?vue&type=script&lang=js"

import "./template-file-upload.vue?vue&type=style&index=0&id=73c35c66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c35c66"]])

export default __exports__